import moment from "moment/moment";
import formatCurrency from "format-currency";
import createSubcontractorModal from "../../../common/modals/createSubcontractorModal/createSubcontractorModal.component";
import addSubcontractorEmployeeModal from "../../../common/modals/addSubcontractorEmployee/addSubcontractorEmployee.component";


class SubcontractorsController {
  constructor($rootScope, $http, toastr, $state, AuthenticationService, $uibModal) {
    "ngInject";
    this.name = 'subcontractors';
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.auth = AuthenticationService;
    this.toastr = toastr;
    this.$state = $state;
    this.customers = [];
    this.$uibModal = $uibModal;

    this.subcontractorFilter = {
      name: '',
      status: 'active'
    }

    this.filterrefresh = false;


    let self = this;

    this.subcontractorColumns = [
      {
        displayName: 'Name',
        value: 'name',
        sortable: true,
        dataType: 'number',
        formatting: function (record) {
          return "<a className=\"text-info\" href=\"admin/subcontractors/"+record.id+"\" >"+record.name+"</a>";
        }
      },
      {
        displayName: 'Short Name',
        value: 'shortName',
        sortable: true,
        dataType: 'text'
      }
    ];

    this.filterCriteria = function () {
      return "status="+self.subcontractorFilter.status+"&name="+self.subcontractorFilter.name;
    }

  }

 filterSubcontractors() {
    this.filterrefresh = true;
 }


  createSubcontractor() {
    let self = this;
    var modalInstance = this.$uibModal.open(createSubcontractorModal);

    modalInstance.success = function (subcontractorName, subcontractorShortName) {
      self.$http.post(self.$rootScope.apiHost+'/api/admin/subcontractors', {id: -1, active: true, name: subcontractorName, shortName: subcontractorShortName}, { withCredentials: true}).then(function (success) {
        modalInstance.dismiss();
        self.$state.go("admin.subcontractor-details", {'subcontractorId': success.data.id});
        self.toastr.success("Successfully Created Subcontractor", "SUCCESS");
      });
    };

    modalInstance.cancel = function () {
      modalInstance.dismiss();
    };
  }

  createSubcontractorEmployee() {
    let self = this;
    var modalInstance = this.$uibModal.open(addSubcontractorEmployeeModal);

    modalInstance.success = function (subcontractorEmployee) {
      self.$http.post(self.$rootScope.apiHost+'/api/admin/subcontractors/'+this.subcontractor.id+'/employees', {name: subcontractorName, shortName: subcontractorShortName}, { withCredentials: true}).then(function (success) {
        modalInstance.dismiss();
        self.$state.go("admin.subcontractor-details", {'subcontractorId': success.data.id});
        self.toastr.success("Successfully Created Subcontractor", "SUCCESS");
      });
    };

    modalInstance.cancel = function () {
      modalInstance.dismiss();
    };
  }




}


export default SubcontractorsController;



// WEBPACK FOOTER //
// ./client/pages/admin/subcontractors/subcontractors.controller.js